import React, { useEffect } from 'react';
import { List } from 'app/components/core/list';
import { PaymentMethod } from 'app/components/payment/PaymentMethod';
import { PaymentMethodsListProps, WidgetStates } from 'app/components/payment/types';

export const PaymentMethodsList = ({
  setPaymentState,
  onTokenReceived,
  isCheckout = true,
  paymentMethods = [],
  activePaymentToken,
}: PaymentMethodsListProps) => {
  useEffect(() => {
    if (!paymentMethods?.length) {
      setPaymentState(WidgetStates.EMPTY_LIST);
    }
  }, [paymentMethods]);

  return !paymentMethods?.length ? null : (
    <List
      items={paymentMethods}
      keyExtractor={(card) => card.token}
      render={(card) => (
        <PaymentMethod
          card={card}
          isCheckout={isCheckout}
          onSelect={onTokenReceived}
          isSelected={activePaymentToken === card.token}
        />
      )}
    />
  );
};
